import { Component, computed, input } from '@angular/core';
import { SkeletonAnimation, SkeletonComponent } from '@progress/kendo-angular-indicators';
import { StackLayoutComponent } from '@progress/kendo-angular-layout';
import { PageActionsLayoutComponent } from '../page-actions-layout/page-actions-layout.component';
import { PageReturnLayout } from '../page-return-layout/page-return-layout';
import { PageStatsLayoutComponent } from '../page-stats-layout/page-stats-layout.component';

@Component({
  selector: 'unity-page-container',
  standalone: true,
  imports: [SkeletonComponent, StackLayoutComponent, PageActionsLayoutComponent, PageStatsLayoutComponent, PageReturnLayout],
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss',
})
export class PageContainerComponent {
  protected animation: SkeletonAnimation = 'wave';

  public readonly $contentHeader = input.required<string>({ alias: 'contentHeader' });
  public readonly $contentHeaderSecondary = input<string | undefined>(undefined, { alias: 'contentHeaderSecondary' });
  public readonly $contentHeaderTertiary = input<string | undefined>(undefined, { alias: 'contentHeaderTertiary' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });

  protected readonly $hasContentHeaderSecondary = computed(() => {
    const contentHeaderSecondary = this.$contentHeaderSecondary();
    return contentHeaderSecondary && contentHeaderSecondary.length > 0;
  });

  protected readonly $hasContentHeaderTertiary = computed(() => {
    const contentHeaderTertiary = this.$contentHeaderTertiary();
    return contentHeaderTertiary && contentHeaderTertiary.length > 0;
  });
}
